import { useEffect } from 'react';

export function useCatalogLeaveConfirmation(isDirty: boolean) {
  useEffect(() => {
    if (!isDirty) return;
    const warnBeforeUnload = (event: BeforeUnloadEvent): void => {
      event.preventDefault();
      event.returnValue = '';
    };
    window.addEventListener('beforeunload', warnBeforeUnload);
    return () => window.removeEventListener('beforeunload', warnBeforeUnload);
  }, [isDirty]);
  return (): boolean => !isDirty || window.confirm('Изменения не сохранены. Выйти без сохранения?');
}
